export default {
  creditCard: 'credit_card',
  other: 'braintree_v_zero',
};
